import React, { forwardRef } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import "./PeregrineBlogCard.css";

const PeregrineBlogCard = forwardRef(
  ({ week, index, expanded, toggleExpand }, externalRef) => {
    // Using useInView at the top level of the component
    const [itemRef, itemInView] = useInView({
      triggerOnce: true,
      threshold: 0.1,
    });

    const positionClass = index % 2 === 0 ? "left" : "right";

    // Improved ref handling to prevent string ref issues
    const setRefs = (element) => {
      // Set the internal ref for intersection observer
      itemRef(element);

      // Set the external ref if provided, ensuring it's handled properly
      if (externalRef) {
        if (typeof externalRef === "function") {
          externalRef(element);
        } else if (externalRef.current !== undefined) {
          externalRef.current = element;
        }
      }
    };

    return (
      <motion.div
        className={`peregrine-timeline-item ${positionClass}`}
        ref={setRefs}
        initial={{ opacity: 0, y: 50 }}
        animate={itemInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.7, delay: index * 0.1 }}
      >
        <div className="peregrine-timeline-marker">
          <FontAwesomeIcon icon={faCalendarAlt} />
          <span>{index + 1}</span>
        </div>

        <div className="peregrine-timeline-content">
          <div className="peregrine-blog-image">
            <img src={week.image} alt={`Week ${index + 1}`} />
            <div className="peregrine-image-overlay"></div>
          </div>

          <div className="peregrine-blog-content">
            <h3>{week.week}</h3>

            <div
              className={`peregrine-blog-description ${
                expanded ? "expanded" : ""
              }`}
            >
              {expanded ? (
                week.description
              ) : (
                <p>
                  {typeof week.description.props.children[0] === "object"
                    ? week.description.props.children[0].props.children
                    : week.description.props.children[0]}
                </p>
              )}
            </div>

            <div className="peregrine-blog-footer">
              <button className="peregrine-read-more" onClick={toggleExpand}>
                {expanded ? (
                  <>
                    Read Less <FontAwesomeIcon icon={faChevronUp} />
                  </>
                ) : (
                  <>
                    Read More <FontAwesomeIcon icon={faChevronDown} />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    );
  }
);

// Add a display name to help with debugging
PeregrineBlogCard.displayName = "PeregrineBlogCard";

export default PeregrineBlogCard;
